import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';

const IMAGE_WIDTH_CAP = 1200;

export class Mike extends Lit3formBlock {
  static get characterName() {
    return 'mike';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid mike-layout">
          <div class="text-column">
            ${this.eyebrowText
              ? html`
                  <p class="eyebrow">${unsafeHTML(this.eyebrowText)}</p>
                `
              : html``}
            <div class="text-block">
              ${this.headerText
                ? html`
                    <h1 class="header">${unsafeHTML(this.headerText)}</h1>
                  `
                : html``}
              ${this.descriptionText
                ? html`
                    <p class="description">
                      ${unsafeHTML(this.descriptionText)}
                    </p>
                  `
                : html``}
            </div>
          </div>
          ${this.imageHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imageHTML() {
    const src = this.image.src;
    return html`
      <div class="image-column">
        <div class="image-holder">
          ${src
            ? html`
                <img
                  src=${this.imagebossUrl(src, IMAGE_WIDTH_CAP)}
                  alt=${this.imageAlt}
                />
              `
            : html``}
        </div>
      </div>
    `;
  }

  get image() {
    return this.content.image || {};
  }

  get imageAlt() {
    return this.image.header || '';
  }
}
Mike.defineElement();
